import React, {Component} from "react";
import moment from 'moment';
// import BootstrapTable from 'react-bootstrap-table-next';
import TransferTable from "../components/transferTable.js";

var config = require('../config.js');
const backend = config.backend;


class TransferGive extends Component {

  _isMounted = false;


  state = {
    id : this.props.id,
    transfers: [],
    check: false
  }


  /**
   * Loads outgoing transfer data on component mount.
   * @param {void} _
   * @return {void}
   */
  componentDidMount() {
    this._isMounted = true;
    this.getPendingTransfers();
  }

  /**
   * Marks component unmounted to avoid stale setState calls.
   * @param {void} _
   * @return {void}
   */
  componentWillUnmount() {
    this._isMounted = false;
  }


  /**
   * Renders sort icon for table headers.
   * @param {Object} column Column metadata.
   * @param {number} index Column index.
   * @param {Object} controls Sort and filter controls.
   * @param {number} length Current row count.
   * @return {JSX.Element} Header with sort icon.
   */
  sortIcon (column, index, { sortElement, filterElement }, length){
    if (length <= 1){
      return (
        <div> {column.text} </div>
      )
    }
    else{
      var {icon} = <i className="material-icons">unfold_more</i>;

      var { order } = sortElement.props;
      if (order === 'desc'){
        icon = <i className="material-icons">keyboard_arrow_up</i>
      }
      else if (order === 'asc'){
        icon = <i className="material-icons">keyboard_arrow_down</i>
      }
      else{
        icon = <i className="material-icons">unfold_more</i>
      }

      return (
        <div>
          {icon} {column.text}
        </div>
      );
    }
  }

  /**
   * Compares date values for sorting behavior.
   * @param {string|Date} a First date.
   * @param {string|Date} b Second date.
   * @param {string} order Sort order.
   * @return {number} Comparator value.
   */
  sortDates (a, b, order) {
    var dateA = new Date(a), dateB = new Date(b);
    if (order === 'asc'){
      return dateA - dateB;
    }
    return dateB - dateA;
  }


  /**
   * Fetches and filters ongoing approved outgoing transfers.
   * @param {void} _
   * @return {void}
   */
  getPendingTransfers = _ => {
    // fetch(`http://localhost:5000/api/staff/all`)
    // fetch(`http://localhost:5000/api/transfer/allpending`).then(response => response.json()).then((response) => {
    fetch(backend + `api/transfer/from/`+this.state.id, {
      method: 'GET',
      credentials: 'include'
    })
    .then(response => response.json())
    .then((response) => {

      fetch(backend + `api/staffsimple`, {
        method: 'GET',
        credentials: 'include'
      })
      .then(res => res.json())
      .then(({data}) => {

        const now = moment();
        var arr = [];

        for (var key in response){
          // console.log(response[key])
          // moment(date).isSameOrAfter(date2, 'month') will check month and year
          if (moment(new Date(response[key]['EndDate'])).isSameOrAfter(now, 'month') && response[key]['Status'] === "approve"){
            // arr[key] = response[key];
            if(response[key]['Comment'] === 'null'){
              delete response[key]['Comment'];
            }

            for (var k in data){

              // if (parseInt((response[key]['ToStaffId']).trim(), 10) === (data[k]['value'])){
              if ( (typeof(response[key]['ToStaffId']) === "number" && response[key]['ToStaffId'] === data[k]['value']) || (typeof(response[key]['ToStaffId']) === "string" && parseInt((response[key]['ToStaffId']).trim(), 10) === (data[k]['value']) ) ){
                response[key]['ToStaffId'] = data[k]['label'];
                arr.push(response[key]);
                break;

              }
            }
            // arr.push(response[key]);
          }
        }

        if (this._isMounted){
          this.setState({transfers: arr});
          this.setState({check: true});
        }

      })
      .catch(err => console.error(err));

    }).catch(err => console.error(err));

  }

  /**
   * Renders outgoing transfer section for loading/empty/data states.
   * @param {void} _
   * @return {JSX.Element} Outgoing transfers panel.
   */
  render() {
    // const {transfers} = this.state.transfers;
    const {transfers} = this.state;
    const {check} = this.state;

    const columns = [{
      dataField: 'ToStaffId',
      text:'TO',
      sort: true,
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      }
    }, {
      dataField: 'Amount',
      text:'AMOUNT (SGD)',
      sort: true,
      formatter: (amount) => {
        return '$ '+amount;
      },
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        'padding-left': '34px'
      }
    }, {
      dataField: 'StartDate',
      text:'FIRST TRANSFER DATE',
      sort: true,
      sortFunc: this.sortDates,
      formatter: (from) => {
        return moment(from).format('DD-MMM-YYYY');
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        'padding-left': '34px'
      }
    }, {
      dataField: 'Times',
      text:'MONTH(S)',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        'padding-left': '34px'
      }
    }, {
      dataField: 'EndDate',
      text:'LAST TRANSFER DATE',
      sort: true,
      sortFunc: this.sortDates,
      formatter: (end) => {
        return moment(end).format('DD-MMM-YYYY');
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);

      },
      style:{
        'padding-left': '34px'
      }
    }, {
      dataField: 'Status',
      text:'STATUS',
      sort: true,
      formatter: (status) => {
        // return status.charAt(0).toUpperCase() + status.substr(1);

        if (status === undefined || status === 'null' || status === null)
        {
          return status;
        }
        else if (status === 'approve')
        {
          return status.charAt(0).toUpperCase() + status.substr(1) + 'd';
        }
        else if (status === 'reject')
        {
          return status.charAt(0).toUpperCase() + status.substr(1) + 'ed';
        }
        else{
          return status.charAt(0).toUpperCase() + status.substr(1);
        }
      }
    }];

    const defaultSorted = [{
      dataField: 'StartDate',
      order: 'desc'
    }];

    if (check === false){
      return (<div className ='transfer-display'>
        <div className='tab'><span>Ongoing Transfers From You</span></div>
        <div className = "transfer-table-container">
        <div className="only-row">Loading...</div>
       </div>
       </div>);
    }

    else{

      if (transfers.length === 0){
        return (<div className ='transfer-display'>
          <div className='tab'><span>Ongoing Transfers From You</span></div>
          <div className = "transfer-table-container">
          <div className="only-row">No Transfer Found</div>
         </div>
         </div>);
      }
      else{
        return (<div className ='transfer-display'>
          <div className='tab'><span>Ongoing Transfers From You</span></div>
          <div className = "transfer-table-container">
            <TransferTable transfers={transfers} pending={false} type="Staff" transferType="Give"/>
            {/* <BootstrapTable bootstrap4 keyField='Id' data={ transfers } columns={ columns } bordered={ false } striped hover defaultSorted={ defaultSorted } /> */}
          </div>
        </div>);
      }

    }

  }
}

export default TransferGive;
